import { Paper, TableContainer, Table, TableBody, TableHead, TableRow, TableCell } from '@mui/material';
import RequirementsListItem from './RequirementsListItem';

const RequirementsListTable = props => {
  return (
    <TableContainer component={Paper}>
      <Table>
        <TableHead color="primary">
          <TableRow>
            <TableCell>ID</TableCell>
            <TableCell>Tipo de prueba</TableCell>
            <TableCell>Centro de costo</TableCell>
            <TableCell>Identificación</TableCell>
            <TableCell>Nombre</TableCell>
            <TableCell>Teléfono</TableCell>
            <TableCell>Comentario</TableCell>
            <TableCell>Estado</TableCell>
            <TableCell align="center" sx={{ verticalAlign: 'middle' }}>Evidencia</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {props.requirements?.map(requirement => <RequirementsListItem key={requirement._id} {...requirement} onDownload={props.onDownload} />)}
        </TableBody>
      </Table>
    </TableContainer>
  );
}

export default RequirementsListTable;
